function NativeCarouselFactory(container) {
  class NativeCarousel {
    constructor(target) {
      if (!target) return;
      this.element = container;
      this.target = target;
      this.carousel = this.element.querySelector("[data-native-carousel]");
      this.prevButton = this.element.querySelector(
        ".native-carousel-arrow--prev"
      );
      this.nextButton = this.element.querySelector(
        ".native-carousel-arrow--next"
      );

      if (!this.carousel || !this.prevButton || !this.nextButton) return;

      this.scrollAmount = 300;

      this._setEvents();
      this._updateArrowVisibility(); // Initial state
    }

    _setEvents() {
      this.prevButton.addEventListener("click", () => {
        this.carousel.scrollBy({
          left: -this.scrollAmount,
          behavior: "smooth",
        });
      });

      this.nextButton.addEventListener("click", () => {
        this.carousel.scrollBy({
          left: this.scrollAmount,
          behavior: "smooth",
        });
      });

      this.carousel.addEventListener("scroll", () =>
        this._updateArrowVisibility()
      );
      window.addEventListener("resize", () => this._updateArrowVisibility());
    }

    _updateArrowVisibility() {
      const scrollLeft = this.carousel.scrollLeft;
      const maxScrollLeft =
        this.carousel.scrollWidth - this.carousel.clientWidth;

      // Handle prev button
      if (scrollLeft <= 0) {
        this._hideArrow(this.prevButton);
      } else {
        this._showArrow(this.prevButton);
      }

      // Handle next button
      if (scrollLeft >= maxScrollLeft - 1) {
        this._hideArrow(this.nextButton);
      } else {
        this._showArrow(this.nextButton);
      }
    }

    _hideArrow(button) {
      button.style.opacity = "0";
      button.style.pointerEvents = "none";
    }

    _showArrow(button) {
      button.style.opacity = "1";
      button.style.pointerEvents = "auto";
    }
  }

  return new NativeCarousel(container);
}
